import {api} from './api'

  export const GetKit = async (data) =>{
    return await api.get(`kits/list`, data);
  }

  export const UpdateKit = async (data) =>{
    return await api.post(`kit/update`, data)
  }

  export const DeleteKit = async (id) =>{
    return await api.get(`kit/delete/${id}`)
  }
  
  export const CreateKit = async (data) =>{
    return await api.post(`kits/create`,data)
  }

  export const ViewKitByID = async (id) => {
    return await api.get(`kit/view/${id}`)
  }